import styled from '@emotion/styled';
import { theme } from '@ublend-npm/aulaui-next';

const { purple70 } = theme.color.designSystem;

export const SpacerButton = styled.button<{ isActive?: boolean }>`
  width: calc(100% - 26px);
  height: 2px;
  margin: 0;
  border: none;
  outline: none;
  padding: 0;
  left: 40px;
  position: relative;
  cursor: pointer;
  display: block;
  z-index: 1;

  opacity: ${({ isActive }) => (isActive ? 1 : 0)};
  background: ${({ isActive }) => (isActive ? purple70 : 'transparent')};

  &:focus {
    background: ${purple70};
  }

  &:before,
  &:after {
    content: ' ';
    background: transparent;
    height: 10px;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }

  &:before {
    top: -10px;
  }

  &:after {
    top: 2px;
  }
`;
